import { createFileRoute } from '@tanstack/react-router'
import { Integrations } from '@/features/b2b2c/integrations'

export const Route = createFileRoute('/_authenticated/b2b2c/integrations/')({
  component: Integrations,
})
